<div class="container">
  <h1>Trasferimenti fondi</h1>
  <p-table
    styleClass="mt-6"
    [value]="list"
    [paginator]="true"
    [rows]="10"
    [lazy]="true"
    (onLazyLoad)="fetch($event)"
    [totalRecords]="count"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
    #dt1
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">Data di richiesta</th>
        <th>Tour leader</th>
        <th class="text-center">Importo</th>
        <th>Conto bancario</th>
        <th>Stato</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-t>
      <tr>
        <td class="text-center">
          {{ t.created_on | date : "dd/MM/yyyy" }}
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <p-avatar
              [image]="t.payout_account.user.profile_picture | imagePipe : 'user' : 'sm'"
              shape="circle"
            ></p-avatar>
            <a
              class="link-o"
              [routerLink]="['/users/detail-user', t.payout_account.user.id]"
              *ngIf="t.payout_account.user.name != undefined"
              ><strong>{{ t.payout_account.user.name }} {{ t.payout_account.user.last_name }}</strong></a
            >
            <a
              class="link-o"
              [routerLink]="['/users/detail-user', t.payout_account.user.id]"
              *ngIf="t.payout_account.user.name == undefined"
              ><strong>{{ t.payout_account.user.username }}</strong></a
            >
          </div>
        </td>
        <td class="text-center">
          {{ t.amount | currency : "EUR" : "symbol" : ".2-2" }}
        </td>
        <td>
          <div class="payout-account">
            <div>
              <h5>{{ t.payout_account.bank_name }}</h5>
              <div class="iban">
                IBAN {{ t.payout_account.iban }}<br />
                SWIFT/BIC {{ t.payout_account.swift_bic }}
              </div>
            </div>
          </div>
        </td>
        <td>
          @switch( t.status.id){ @case(enumPayoutTransferStatus.ANNULLATA){
          <div class="flex align-items-center gap-2 text-sm">
            <i class="text-purple-700 pi pi-times"></i>
            <span class="text-purple-700">Annullata</span>
          </div>
          } @case(enumPayoutTransferStatus.EVASA){
          <div class="flex align-items-center gap-2 text-sm">
            <i class="text-teal-600 pi pi-check"></i>
            <span class="text-teal-600">Evasa</span>
          </div>
          } @case(enumPayoutTransferStatus.IN_LAVORAZIONE){
          <div class="flex align-items-center gap-2 text-sm">
            <i class="text-orange-600 pi pi-spinner"></i>
            <span class="text-orange-600">In lavorazione</span>
          </div>
          } }
        </td>
        <td>
          <div class="mx-auto">
            <p-button
              icon="pi pi-ellipsis-h"
              (click)="selectedTransfer = t; menuAccount.toggle($event)"
              [text]="true"
            ></p-button>
            <p-menu
              #menuAccount
              [model]="account_menu"
              [popup]="true"
              appendTo="body"
            ></p-menu>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">
          <div class="empty-set px-0">
            <h5>Nessun risultato.</h5>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
